import React, { useState, useEffect, useRef } from 'react';
import './testimonials.css';
import { Link } from 'react-router-dom';

const recommendations = [
  {
    name: "Sofia Hagberg",
    role: "Student, Linköpings Universitet",
    message: "Penny has helped me tremendously. By collecting all the offers and providing navigation, I have saved thousands of SEK which I could spend on other things."
  },
  {
    name: "Erik Johansson",
    role: "Working professional, Stockholm",
    message: "I've cut my grocery bill by 25% using Penny's recommendations. The app pays for itself every month!"
  },
  {
    name: "Maria Andersson",
    role: "Parent of three, Gothenburg",
    message: "With three kids, grocery shopping was always stressful and expensive. Penny helps me plan meals and find the best deals in one place."
  },
  {
    name: "Johan Lindberg",
    role: "Retired, Malmö",
    message: "On a fixed income, every penny counts. Penny helps me stretch my budget without compromising on quality."
  },
  {
    name: "Astrid Nilsson",
    role: "University student, Uppsala",
    message: "As a student on a tight budget, Penny has been a game-changer for my finances and eating habits!"
  }
];

// Predefined positions for a more controlled layout
const positions = [
  { top: '15%', left: '30%' },
  { top: '40%', left: '55%' },
  { top: '70%', left: '40%' },
  { top: '25%', left: '65%' },
  { top: '60%', left: '20%' }
];

function RecommendationPopups() {
  const [visibleRecommendations, setVisibleRecommendations] = useState([]);
  const animationStarted = useRef(false);
  const containerRef = useRef(null);

  const startAnimationSequence = () => {
    let timeouts = [];
    
    // Display each recommendation with a delay
    recommendations.forEach((recommendation, index) => {
      const timeout = setTimeout(() => {
        const newRecommendation = {
          ...recommendation,
          id: `rec-${index}`,
          position: positions[index % positions.length],
          visible: true
        };
        
        setVisibleRecommendations(prev => [...prev, newRecommendation]);
      }, index * 800); // Stagger the appearance
      
      timeouts.push(timeout);
    });
    
    // Cleanup function
    return () => {
      timeouts.forEach(timeout => clearTimeout(timeout));
    };
  };

  // Start animation sequence when component is in viewport
  useEffect(() => {
    const el = containerRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !animationStarted.current) {
          startAnimationSequence();
          animationStarted.current = true;
        }
      },
      { threshold: 0.1 }
    );

    if (el) {
      observer.observe(el);
    }

    return () => {
      if (el) {
        observer.unobserve(el);
      }
    };
  }, []);
  
  return (
    <div className="recommendations-big-container">
        <div className="recommendations-header">
                <h6>Testimonials</h6>
        </div>
        <div className="recommendation-container" ref={containerRef}>
        {visibleRecommendations.map(rec => (
            <div 
            key={rec.id}
            className="recommendation-popup"
            style={{
                top: rec.position.top,
                left: rec.position.left
            }}
            >
            <div className="recommendation-content">
                <p className="recommendation-message">"{rec.message}"</p>
                <div className="recommendation-author">
                <p className="recommendation-name">{rec.name}</p>
                <p className="recommendation-role">{rec.role}</p>
                </div>
            </div>
            </div>
        ))}
        </div>
        <div className="testimonial-button-container">
            <Link to="/deals" className="testimonial-button-link">
                <button className="testimonial-button">
                    Visit this week's offers
                </button>
            </Link>
        </div>
    </div>
  );
}

export default RecommendationPopups;